<template>
    <el-dialog width="550px" :close-on-click-modal='false' :close-on-press-escape='false' :visible.sync="dialogVisible" :show-close='false'>
        <el-form ref="form" :model='formState' :rules="rules" :label-width="isLapTop ? '250px' : '270px'">
            <el-form-item label="请您选择首次登陆系统的语言类型(Please select the language type for the first time)：" prop='lang'>
                <el-select v-model="formState.lang">
                    <el-option v-for="option in languages" :label='option.desc' :key='option.value' :value='option.value'></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;">
            <el-button type="primary" @click='onEnter'>进入（Enter）</el-button>
            <!-- <el-button type="primary" @click='onCancel'>取消（Cancel）</el-button> -->
        </div>
    </el-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    data(){
        const freeze = Object.freeze;
        return {
            formState: {
                lang: '',
            },
            languages: freeze([
                {
                    desc: "简体中文",
                    value: "zh_CN",
                },
                {
                    desc: "繁體中文",
                    value: "zh_TW", 
                },
                {   
                    desc: "English",
                    value: "en_US",
                },
            ]),
            rules: {
                lang: {
                    required: true,
                    message: '请选择语言(Please select the language)'
                }
            }
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false, 
        }
    },
    methods: {
        ...mapActions(['handleSetLanguage']),
        onEnter(){
            this.$refs.form.validate((isValid) => {
                if (isValid) {
                    const { lang } = this.formState;
                    this.handleSetLanguage(lang);
                }
            })
        },
        onCancel(){
            window.close();
            setTimeout(() => {
                window.history.go(-1);
            })
        }
    },
    created(){

    }
}
</script>